/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// Recipe Kit Cart Event Listener
  // - event is dispatched everytime a cart item is added/removed from the recipe card
  // - use below function to update your sidebar/ajax cart number as needed.
  document.addEventListener('rk_cart_event', function (e) {
    // cart variable includes entirety of newly updated Shopify Cart, use accordingly
    var cart = e.detail.cart;
    console.log(cart);
    // below is example of the "Galleria" theme, they have a global "Shopify" function we can call to update the cart    
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    $('.Header__Icon[data-drawer-id="sidebar-cart"]')[0].click();
  }, false);
// Recipe Kit Cart Event Listener


jQuery(window).scroll(function() {    
  var scroll = jQuery(window).scrollTop();

  if (scroll >= 100) {
    jQuery("#section-header").addClass("darkHeader");
  } else {
    jQuery("#section-header").removeClass("darkHeader");
  }
});

$(document).ready(function(){

  $(".details-btn").click(function(){
    $(this).next().slideToggle();
    $(this).toggleClass('active');
  });

  $('#shopify-section-inspiration-collection .ProductList').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          autoplay: true,
          infinite: true,
          autoplaySpeed: 2000,
          slidesToScroll: 1
        }
      }
    ]
  });

  if ($(window).width() < 769) {
      $('#shopify-section-featured-collections .ProductList ,  section.home-feature-collection.full-home-feature-collection .ProductList , .product-image-text-column .column-section .flexbox').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          autoplay: true,
          infinite: true,
          autoplaySpeed: 2000,
          slidesToScroll: 1
        }
      }
    ]
  });
  };

$('.image-slider-section .image-group').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    fade: true
  });


  $('.Product__Slideshow').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    fade: false,
    asNavFor: '.thumbnails-slider',
    responsive: [
     {
        breakpoint: 768,
        settings: {
          arrows: true
        }
      }
    ]
  });
  
  $('.thumbnails-slider').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: '.Product__Slideshow',
    dots: false,
    infinite: false,
    focusOnSelect: true
  });




  $('.home-artical-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          autoplay: true,
          infinite: true,
          autoplaySpeed: 2000,
          slidesToScroll: 1
        }
      }
    ]	
  });
  if ( $(window).width() < 768 ) {
     $('.collections-iconlist .flexbox').slick({
      slidesToShow: 6,
      slidesToScroll: 3,
      arrows: false,
      dots: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            autoplay: true,
            infinite: true,
            autoplaySpeed: 2000,
            slidesToScroll: 1
          }
        }
      ]	
    });
  
    $('.pagelogo-slider').slick({
    slidesToShow: 6,
    slidesToScroll: 3,
    arrows: false,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          autoplay: true,
          infinite: true,
          autoplaySpeed: 2000,
          slidesToScroll: 1
        }
      }
    ]	
  });
  }
  $('.about-our-mission-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    fade: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]	
  });
  
  $('.collections_image .section-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    fade: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]	
  });

//   document.addEventListener('product:added', function(event) {
//       jQuery.getJSON('/cart.js', function (cart, textStatus) {
//         console.log(cart);
//         if(cart.item_count < 3 ){
// 			console.log(3 - parseInt(cart.item_count));
//           $(".cart-tag-line p span.add_more").text(3 - parseInt(cart.item_count));
//         }else{
//         	$(".cart-tag-line p ").text("YOU GOT FREE SHIPPING!");
//         }
//       });
//   });
  
  
     document.addEventListener('product:added', function(event) { 
      jQuery.getJSON('/cart.js', function (cart, textStatus) {
        //console.log(cart);
        if(cart.item_count < 3 ){
          console.log('< 3');
			console.log(3 - parseInt(cart.item_count));
          $(".cart-tag-line p span.add_more").text(3 - parseInt(cart.item_count));
        }else{
          console.log('free');
          $(".cart-tag-line p ").text("YOU GOT FREE SHIPPING!");
        }
      });
     });  

  
  /* collection page add prod to blank div below list */
  /*$(".single_collection .ProductItem").on("click",function(e){
    e.preventDefault();
    $.ajax({
      url:$(this).data("product-link"),
      type:'GET',
      success: function(data){
        $('.product-details').html($(data).find('div.Product__Wrapper').html());
        $('.Product__Slideshow').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: true,
          fade: false,
          asNavFor: '.thumbnails-slider'
        });
        
        $('.thumbnails-slider').slick({
          slidesToShow: 7,
          slidesToScroll: 1,
          asNavFor: '.Product__Slideshow',
          dots: false,
          infinite: true,
          focusOnSelect: true
        });
        
        
        $('[data-action="increase-quantity"]').on("click",function(e){
         $(this).prev().val(parseInt($(this).prev().val()) + 1);
        });
        
         $('[data-action="decrease-quantity"]').on("click",function(e){
           $(this).next().val(Math.max(parseInt($(this).next().val()) - 1, 1));
         });
        $('html, body').animate({
          scrollTop: $(".product-details").offset().top
        }, 1500);
      }
    });
  });*/
  

  if ( $('.slideshow').length > 0 ){
    $(window).on('resize orientationChange', function(event) {$('.slideshow').slick('refresh');});
  }

  if ($(window).width() < 861) {
      $('footer .featured-logo-section .flexbox').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
        {
          breakpoint: 420,
          settings: {
          slidesToShow:2,
          slidesToScroll: 1
        }
      }
    ]	
    });  
  }

  $('.chef-review-section-main .review-grid-main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000
  });


});



